import script from "./ProjectSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectSelector.vue?vue&type=script&setup=true&lang=js"

import "./ProjectSelector.vue?vue&type=style&index=0&id=6a351c89&lang=scss"

const __exports__ = script;

export default __exports__